// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ar from './local/ar.json';
import en from './local/en.json';
const storedLang = localStorage.getItem('i18nextLng');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: storedLang || 'ar',
    supportedLngs: ['en', 'ar'],
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      // Add this if language is not changing
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
